import { MobilePaymentsPage } from "libs/client/dex-tech-fe/docs/feature-dex-tech-docs-mobile-payments-sdk/src/lib/MobilePaymentsPage";

const Page = () => {
  return <MobilePaymentsPage platform="android" />;
};

export default Page;
